import { createFileRoute } from "@tanstack/react-router";
import { ArticleLayout } from "@/components/article-layout";
import { getArticle } from "@/content/articles";
import { abs, articleHead } from "@/content/seo";
import ogSocial from "@/assets/og-sylwia-sitkowska.jpg";

const article = getArticle("stres-w-pracy-a-decyzje");

export const Route = createFileRoute("/stres-w-pracy-a-decyzje")({
  head: () => articleHead(article, abs(ogSocial)),
  component: () => <ArticleLayout article={article} />,
});
